const expandPainelItemLabelformActions = {
  local: 'Local',
  equipment: 'Equipamento',
  equipmentReference: 'Ponto de referência',
  service: 'Serviço',
  questionGroup: 'Grupo da Questão',
  questionText: 'Questão',
  actionBy: 'Ação criada por',
  sn: 'S/N',
  description: 'Descrição',
  text: 'Sem S/N'
};

export default expandPainelItemLabelformActions;
